module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-radio-group', {
    staticClass: "compact",
    attrs: {
      "outlined": "",
      "value": _vm.value,
      "mandatory": false,
      "label": _vm.schema.label
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  }, _vm._l((_vm.schema.items), function(item, index) {
    return _c('v-radio', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-159fc42b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/controls/RadioControl.vue
// module id = 2461
// module chunks = 1